var randomHex = function randomHex(size, callback) {
  var crypto = require('./crypto.js');

  var isCallback = typeof callback === 'function';

  if (size > 65536) {
    if (isCallback) {
      callback(new Error('Requested too many random bytes.'));
    } else {
      throw new Error('Requested too many random bytes.');
    }
  }

  ; // is node

  if (typeof crypto !== 'undefined' && crypto.randomBytes) {
    if (isCallback) {
      crypto.randomBytes(size, function (err, result) {
        if (!err) {
          callback(null, '0x' + result.toString('hex'));
        } else {
          callback(error);
        }
      });
    } else {
      return '0x' + crypto.randomBytes(size).toString('hex');
    } // is browser

  } else {
    var cryptoLib;

    if (typeof crypto !== 'undefined') {
      cryptoLib = crypto;
    } else if (typeof msCrypto !== 'undefined') {
      cryptoLib = msCrypto;
    }

    if (cryptoLib && cryptoLib.getRandomValues) {
      var randomBytes = cryptoLib.getRandomValues(new Uint8Array(size));
      var returnValue = '0x' + Array.from(randomBytes).map(function (arr) {
        return arr.toString(16);
      }).join('');

      if (isCallback) {
        callback(null, returnValue);
      } else {
        return returnValue;
      } // not crypto object

    } else {
      var error = new Error('No "crypto" object available. This Browser doesn\'t support generating secure random bytes.');

      if (isCallback) {
        callback(error);
      } else {
        throw error;
      }
    }
  }
};

module.exports = randomHex;